<template>
  <v-dialog
    @keydown.esc="isOpen=false"
    v-model="isOpen"
    width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon
        small
        depressed
        class="custom-button"
      >
        <v-icon color="primary">mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Nueva sección
      </v-card-title>
      <v-card-text>
        <v-form v-model="isValid" ref="createSection">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                  v-model="form.data.name"
                  label="Nombre de la sección nueva"
                  :rules="form.rules.name"
                  required/>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="this.form.data.area"
                  :label="$t('recipes.labels.area')"
                  readonly
                  required/>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="form.data.priority"
                  :rules="form.rules.priority"
                  label="Prioridad"
                  maxlength="1"
                  required/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-4"
          outlined
          rounded
          small
          depressed
          @click="closeSectionDialog">
          {{ $t('ctas.close') }}
        </v-btn>
        <v-btn
          color="primary"
          rounded
          small
          depressed
          :disabled="!isValid"
          @click="createSection">
          {{ $t('ctas.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      overlay: false,
      isOpen: false,
      isValid: false,
      form: {
        data: {
          name: null,
          area: null,
          priority: null
        },
        rules: {
          name: [v => !!v || `${this.$i18n.t('recipes.labels.name')} ${this.$i18n.t('messages.isRequired')}`],
          priority: [
            v => /[0-9]/.test(v) || 'Enter a valid number',
            v => v.length === 1 || 'Phone must be a 1 digits long'
          ]
        }
      }
    }
  },
  watch: {
    isOpen: async function (value) {
      if (value) {
        this.form.data.area = this.$store.state.area.name
      }
    }
  },
  computed: {
    currentArea () {
      return this.$store.state.area || {}
    }
  },
  methods: {
    closeSectionDialog () {
      this.isOpen = false
      this.form.data.name = null
      this.form.data.area = null
      this.$refs.createSection.reset()
      this.$emit('close', false)
    },
    async createSection () {
      this.$refs.createSection.validate()
      if (this.isValid) {
        this.overlay = true
        try {
          const response = await this.$api.post(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/sections`, {
            name: this.form.data.name,
            restaurant: this.$store.state.currentRestaurant.data._id,
            area: this.currentArea._id,
            priority: this.form.data.priority
          })
          this.$toasted.show(`La sección ${this.form.data.name} se creó exitosamente`, { duration: 3000 })
          await this.$store.commit('currentRestaurant/sections/get', response)
          this.closeSectionDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    }
  }
}
</script>
<style>
.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-top: 10px;
}
</style>
